import aa from "../AdminPortal/adminApp.module.css";

export const DEFAULT_TIME_PRESETS = [
  "08:00",
  "10:00",
  "12:00",
  "14:00",
  "16:00",
  "18:00",
];

export default function TimePresetChips({
  value,
  onChange,
  presets = DEFAULT_TIME_PRESETS,
  label = "Быстрый выбор",
  disabled = false,
}) {
  return (
    <div className={aa.calSlotDurationRow} role="group" aria-label={label}>
      <span className={aa.calSlotDurationLabel}>{label}</span>
      {presets.map((time) => (
        <button
          key={time}
          type="button"
          disabled={disabled}
          className={`${aa.calSlotDurationChip} ${
            value === time ? aa.calSlotDurationChipOn : ""
          }`}
          onClick={() => onChange(time)}
        >
          {time}
        </button>
      ))}
    </div>
  );
}
